module.exports = __webpack_public_path__ + "static/media/default_image.0171ad20.svg";